<template>
  <div class="countries" aria-label="Страны проекта">
    <button type="button" v-for="country in countries" @click="setActiveCountry(country.code);changeCountry(country, project_id);"
            :class="'country' + (active_country?.code===country.code?' active':'')" style="padding: 0 3px;">
      <div class="">
                <span class="flag">
              <i :class="`${country.code.toLowerCase()}`" :title="country.name"></i>
              </span>
                  </div>
    </button>
  </div>
</template>

<script>
export default {
  name: "CountryChoice",
  props: ['project_id', 'active_country', 'countries', 'changeCountry'],
  data() {
    return {}
  },
  methods: {
    setActiveCountry(country) {
      if (this.project_id) {
         let data = {projects: {}}
        data.projects[this.project_id] = {country_code: country}
        this.$store.dispatch("setSettings", data)
      }
    }
  }

}
</script>

<style scoped lang="scss">
.flag i {
    width: 32px;
    height: 32px;
}
</style>
